import useAzureSpeech from "shared/hooks/useAzureSpeech";

const useAzureSpeechProvider = (callbacks) => {
    const azure = useAzureSpeech(callbacks);

    return {
        initConfigs: azure.initConfigs,
        initAzureSpeech: azure.initAzureSpeech,
        initSynthesizer: azure.initSynthesizer,
        startListening: azure.startListening,
        stopListening: azure.stopListening,
        synthesizeText: azure.synthesizeText,
        disposeAzureSpeech: azure.disposeAzureSpeech,
        updateAuthToken: azure.updateAuthToken,
        sessionRef: azure.sessionRef,
    };
};

export default useAzureSpeechProvider;
